import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissAutoComplete } from 'components/autocompletes/CissAutoComplete';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function DadosEntregaListFilter() {
    const [filterEstado, setFilterEstado] = useState<FilterValuesProps>({
        property: 'idEstado',
        operator: 'in',
        value: null,
        idProperty: 'idEstado',
    });

    return (
        <Filter preventQueryParamsEmptyStart filters={[{ value: filterEstado, setter: setFilterEstado }]}>
            <Grid sx={{ flex: 4 }}>
                <CissAutoComplete
                    label="Estado"
                    value={filterEstado.value || null}
                    multiple={false}
                    requestOptions={{
                        url: '/gestao/estado',
                        sort: [{ property: 'sgEstado', direction: 'ASC' }],
                        columns: 'idEstado,dsEstado,sgEstado',
                    }}
                    isOptionEqualToValue={(option, value) => option.idEstado === value.idEstado}
                    optionStringTemplate="<strong>{idEstado}</strong> - {dsEstado}"
                    selectedStringTemplate="{dsEstado}"
                    onChange={(e, value) => setFilterEstado((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>
        </Filter>
    );
}
